import React from 'react';

const ReportMedicareDescription = (
  <>
    <h2 className="vads-u-font-size--h3">Report Medicare</h2>
    <ul>
      <li>
        <strong>
          If the applicants pre-enrolled or currently have Medicare
        </strong>
        , we need the plan information. This helps us coordinate benefits and
        process claims faster.
      </li>
      <li>
        <strong>
          If the applicants are age 65 or older and don’t qualify for Medicare
        </strong>
        , we need proof of Medicare ineligibility. This helps us confirm that
        they don’t qualify for Medicare under anyone’s Social Security number.
      </li>
    </ul>
  </>
);

export default ReportMedicareDescription;
